<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <SkillsContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import SkillsContent from "~~/codepresso-renewal/content/SkillsContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "AI 역량 진단·맞춤 교육 플랫폼 | 코드프레소",
  meta: [
    { name: "description", content: "AI를 얼마나 아는지가 아니라 업무에서 얼마나 잘 쓰는지 진단하고, 부족한 역량만 맞춤 교육으로 채워 재진단으로 성장을 증명합니다." },
    { name: "title", content: "AI 역량 진단·맞춤 교육 플랫폼 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "AI 역량 진단·맞춤 교육 플랫폼 | 코드프레소" },
    { property: "og:description", content: "AI를 얼마나 아는지가 아니라 업무에서 얼마나 잘 쓰는지 진단하고, 부족한 역량만 맞춤 교육으로 채워 재진단으로 성장을 증명합니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/skills.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
